module.exports = __webpack_public_path__ + "assets/images/4-23.db8b59fb.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@int/signature/assets/images/preview/4-23.png
// module id = 2104
// module chunks = 0